import {post} from './axios.js'//引入封装的文件中的post方法
import {get} from './axios.js'//引入封装的文件中的get方法
export default {
  //登录接口，params是接口所需参数，‘api/v2/auth’是接口地址中不同的后半部分
  //注：此接口是get请求接口，post请求，只需要将return get()换成return post()即可

  /*通用接口*/
  // http://www.china-crown.com/index.php/api/v1/
  // http://www.china-crown.com/index.php/api/v1/index/seo?id=1
  // GET获取seo
  index_seo(params) {
    return get('index/seo', params)
  },
  // GET资料设定
  basis_bottomInfo(params) {
    return get('basis/bottomInfo', params)
  },
  // GET获取banner图
  basis_getBanner(params) {
    return get('basis/getBanner', params)
  },
  // GET友情链接
  basis_link(params) {
    return get('basis/link', params)
  },
  // GET获取城市
  basis_getCity(params) {
    return get('basis/getCity', params)
  },
  // GET获取图形验证码
  basis_findCaptcha(params) {
    return get('basis/findCaptcha', params)
  },
// POST上传图片
  basis_uploadImage(params) {
    return post('basis/uploadImage', params)
  },
// POST用户登录
  basis_userLogin(params) {
    return post('basis/userLogin', params)
  },
  // POST用户注销
  basis_userLogout(params) {
    return post('basis/userLogout', params)
  },


  /*首页*/
  // GET首页
  index_getIndex(params) {
    return get('index/getIndex', params)
  },
// GET首页外链
  index_link(params) {
    return get('index/link', params)
  },


  /*新闻*/
  // GET新闻类别
  news_getNewsType(params) {
    return get('news/getNewsType', params)
  },
  // GET新闻列表
  news_getNewslist(params) {
    return get('news/getNewslist', params)
  },
// GET新闻详情
  news_getNewsContent(params) {
    return get('news/getNewsContent', params)
  },


  /*下载中心*/
  // GET产品目录列表
  product_getpdfList(params) {
    return get('product/getpdfList', params)
  },
// GET产品视频分类
  product_getVideoType(params) {
    return get('product/getVideoType', params)
  },
  // GET产品视频列表
  product_getVideoList(params) {
    return get('product/getVideoList', params)
  },
// GET产品资料分类类型
  product_productClass(params) {
    return get('product/productClass', params)
  },
  // POST产品资料列表
  product_productInfoList(params) {
    return post('product/productInfoList', params)
  },

  /*品牌故事*/
  // GET荣誉资质
  brandstore_honor(params) {
    return get('brandstore/honor', params)
  },
  // GET全球布局
  brandstore_globalLayout(params) {
    return get('brandstore/globalLayout', params)
  },
  // GET品牌文化
  brandstore_brandCulture(params) {
    return get('brandstore/brandCulture', params)
  },

  // GET品牌故事
  brandstore_brandStore(params) {
    return get('brandstore/brandStore', params)
  },
  // GET发展历程
  brandstore_developHistory(params) {
    return get('brandstore/developHistory', params)
  },

  /*用户中心*/
// GET服务网点
  usercenter_serviceNetwork(params) {
    return get('usercenter/serviceNetwork', params)
  },
// GET如何找到我们-集团总部
  usercenter_findGroup(params) {
    return get('usercenter/findGroup', params)
  },
// GET如何找到我们-经销商网点
  usercenter_dealerOutlets(params) {
    return get('usercenter/dealerOutlets', params)
  },
  // GET维保政策
  usercenter_policy(params) {
    return get('usercenter/policy', params)
  },
  // GET识别皇冠工具
  usercenter_tool(params) {
    return get('usercenter/tool', params)
  },
  // GET工具使用指南
  usercenter_toolGuide(params) {
    return get('usercenter/toolGuide', params)
  },
  // POST用户反馈
  usercenter_userFeedback(params) {
    return post('usercenter/userFeedback', params)
  },

  /*联系我们*/
  // GET联系我们
  contactus_contactUs(params) {
    return get('contactus/contactUs', params)
  },
  // GET人才招聘列表
  contactus_recruit(params) {
    return get('contactus/recruit', params)
  },
  // GET人才招聘-工作地点
  contactus_workAddress(params) {
    return get('contactus/workAddress', params)
  },
  // GET人才招聘-职位类型
  contactus_positionType(params) {
    return get('contactus/positionType', params)
  },
  // POST提交简历
  contactus_submitResume(params) {
    return post('contactus/submitResume', params)
  },
  // GET招商加盟-获取代理品类
  contactus_getAgent(params) {
    return get('contactus/getAgent', params)
  },
  // POST招募加商-提交代理信息
  contactus_submitAgent(params) {
    return post('contactus/submitAgent', params)
  },

  /*产品中心*/
  // GET获取产品分类
  basis_productClass(params) {
    return get('basis/productClass', params)
  },
  // GET获取所有产品分类
  basis_productClassTwo(params) {
    return get('basis/productClassTwo', params)
  },
  // GET产品列表
  product_productList(params) {
    return get('product/productList', params)
  },
  // GET产品详情
  product_productDetail(params) {
    return get('product/productDetail', params)
  },
  // GET定制化方案分类
  product_productZi(params) {
    return get('product/productZi', params)
  },
}

